import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.prueflauf-bild-hinzufuegen';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPrueflaufBildHinzufuegenEffects {

    PrueflaufBildHinzufuegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_PRUEFLAUF_BILD_HINZUFUEGEN),
        mergeMap((x: ac.PostPrueflaufBildHinzufuegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postPrueflaufBildHinzufuegen(x.prueflaufBildRequest).pipe(
                map((result: any) => {
                    return new ac.PostPrueflaufBildHinzufuegenErfolgreichAction(result, x.prueflaufBildRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostPrueflaufBildHinzufuegenFehlerAction(error, x.prueflaufBildRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.PrueflaufCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.PrueflaufCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.PrueflaufCommandService);
        }
        return this.service;
    }
}
